import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import { constants } from '../constants';

const { LBX_THEME_MAP } = constants;

export function LbxTheme(props) {

  const { children, theme, className, applyThemeBackground, htmlTag, darkOverride, inherit, ignoreGlobalTheme, blurredBackground } = props;
  const themeKey = theme.toLowerCase().replace(' ', '_');
  const Tag = htmlTag;

  return (
    <Tag className={
      classNames({
        [className]: className,
        [`${LBX_THEME_MAP[themeKey]}`]: !darkOverride && !ignoreGlobalTheme,
        [`lbx-theme-${themeKey}`] : !inherit,
        'apply-lbx-theme-background': applyThemeBackground,
      }) + ` ${darkOverride ? 'dark-theme' : ''}`}
      >
      { children }
    </Tag>
  )
};

LbxTheme.defaultProps = {
  htmlTag: 'div',
  applyThemeBackground: false,
  darkOverride: false,
  inherit: false,
  ignoreGlobalTheme: false
};

LbxTheme.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.node
  ]).isRequired,
  theme: propTypes.string.isRequired,
  className: propTypes.string,
  applyThemeBackground: propTypes.bool,
  htmlTag: propTypes.string,
  darkOverride: propTypes.bool,
  inherit: propTypes.bool,
  ignoreGlobalTheme: propTypes.bool
};